import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LightType } from 'pages/b2b/Light/types';

import { lightInitialState } from './constants';

const lightSlice = createSlice({
  name: 'light',
  initialState: lightInitialState,
  reducers: {
    setLights: (state, action: PayloadAction<LightType[]>) => {
      state.lights = action.payload;
    },
    updatLightValue: (state, action: PayloadAction<any>) => {
      for (let i = 0; i < state.lights.length; i++) {
        const found = state.lights[i].instructions.find(
          (instruction) => instruction.id === action.payload.id,
        );

        if (found) {
          found.value.default = action.payload.value;
          break;
        }
      }
    },
  },
});

export const { setLights, updatLightValue } = lightSlice.actions;

export default lightSlice.reducer;
